module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgements#acknowledgements"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITOR’S NOTE AND ACKNOWLEDGMENTS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/forward#forward"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOREWORD BY RICK ATKINSON")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introduction"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter01#ch01"
    }
  }, [_c('strong', [_vm._v("Part 1")]), _c('br'), _vm._v("From Manhattan to Cairo, September–October 1942")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 2")]), _c('br'), _vm._v("Cairo Journal, October–November 1942")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 3")]), _c('br'), _vm._v("In Pursuit of Rommel (Libya), November 1942–February 1943")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 4")]), _c('br'), _vm._v("Victory in Tunisia, March–April 1943")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 5")]), _c('br'), _vm._v("Sicily, July–August 1943")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/afterword#afterword",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AFTERWORD")]), _c('br'), _vm._v("Command Sergeant Major Ben Franklin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocsec2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("APPENDIX")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 69
// module chunks = 0